export default "__VITE_ASSET__51b414f2__"